export const apiEndpoints = {
    loginUrl: `admin/auth/login`,
    signUrl: `admin/auth/signup`,
    forgetUrl: 'admin/auth/forgot_password',
    otpVerifyUrl: "admin/auth/verify_otp",
    resendOtpUrl: "admin/auth/resend_otp",
    changePasswordUrl: "admin/auth/change_password",
    resetPasswordUrl: "admin/auth/reset_password",
    profileUrl: "admin/auth/details",
    commonContentUrl: "common/common_content",
    commonContentUpdateUrl: "admin/common/common_content",
    faqGetUrl: "admin/common/question",
    faqCommonUrl: "admin/common/question",
    userGetUrl: "admin/user/list",
    userDetailsUrl: "admin/user/details",
    userStatusUrl: "admin/user/status",
    userDashboardUrl: "admin/user/dashboard",
    faqUpdateUrl: "admin/common/updatequestion",
    getProfileData: "admin/auth/details",
    updatePassword: "admin/auth/change_password",
    updateAdmin: "admin/auth/profile",
    getDashboardUrl: "admin/auth/dashboard_count",
    getTrackingUrl: "admin/product/tracking/list",
    getTrackingDataDetails: 'admin/product/tracking/details',
    updatTrackingStatusUrl: 'admin/product/tracking/edit',
    updateProductDelete: 'admin/product/tracking/delete',
    getTipsUrL: "admin/common/types",
    commonTipsUpdateUrl: "admin/common/update_tips",
    getSubTipsUrl: "admin/common/sub_types",
    commonSubTipsUpdateUrl: "admin/common/update_sub_types",
    exportUsers: "/admin/user/export_users",

    addHealthFitnessUrl: "health/add_health_data",
    getHealthDataUrl: "health/listing",
    updateHealthStatusUrl: "health/update_health_data",
    getFitnessItemDetailsUrl: "health/detail",

    addInvestUrl: "invest/add_invest_data",
    getInvestDataUrl: "invest/listing",
    updateInvestStatusUrl: "invest/update_invest_data",
    getInvestItemDetailsUrl: "invest/detail",

    addAiTipsUrl: "aiTips/add_ai_tips",
    getAiTipsDataUrl: "aiTips/listing",
    updateAiTipsStatusUrl: "aiTips/update_ai_data",
    getAiTipsItemDetailsUrl: "aiTips/detail",


    addProductUrl: "shop/add_shop_data",
    getProductDataUrl: "shop/listing",
    updateProductStatusUrl: "shop/update_shop_data",
    getProductItemDetailsUrl: "shop/detail",


    getMeditationDataUrl: "meditation/listing_meditation_category",
    addMeditationUrl: "meditation/add_meditation_category",
    updateMeditationStatusUrl: "meditation/update_meditation_category",
    getMeditationDetailsUrl: "meditation/getDetailMedCategory",
    /////

    getMeditationItemsUrl: "meditation/meditation_list_by_category",
    getMeditationItemDetails: "meditation/getDetailMedCategory",
    addMeditationItemsUrl: "meditation/add_meditation_data",
    updateMeditationItemsStatusUrl:"meditation/update_meditation_data",
    getMeditationItemDetailsUrl: "meditation/detail"
}